const root = "/project-offices";
const projectOfficesEndpoints = {
    all: () => root,
};
export { projectOfficesEndpoints };
